export default __webpack_public_path__ + "static/media/19.038c3a21.webp";